import { render, staticRenderFns } from "./Server.vue?vue&type=template&id=8a37d63e&"
import script from "./Server.vue?vue&type=script&lang=js&"
export * from "./Server.vue?vue&type=script&lang=js&"
import style0 from "./Server.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports